import { createStore } from "vuex";
import { config } from "vuex-module-decorators";

import AuthModule from "@/store/modules/AuthModule";
import ChannelModule from "@/store/modules/ChannelModule";
import ProgramModule from "@/store/modules/ProgramModule";

config.rawError = true;

const store = createStore({
  modules: {
    AuthModule,
    ChannelModule,
    ProgramModule,
  },
});

export default store;
